/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAiBooks = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M15 4h-.82l2.667 16h2.972l-1.305-7.836 1.972-.328L22.181 22h-7.028L14 15.082V22H2V2h13zM4 20h3v-2H4zm5 0h3v-2H9zm-5-4h3V8H4zm5 0h3V8H9zM4 6h3V4H4zm5 0h3V4H9z" />
        <path d="M20.558 4.39 23 6l-2.442 1.61L19 10l-1.559-2.39L15 6l2.441-1.61L19 2zm-2.01 1.2-.137.09-.485.32.485.32.138.09.451.692.451-.692.622-.41-.622-.41L19 4.897z" />
      </g>
    </g>
  </Icon>
);
export { SvgAiBooks as AiBooks };
